const RemoveType = {
    AllVersions: 'all-versions',
    LastVersion: 'last-version',
}

export default RemoveType;
